import {makeObjectFromArray} from "utils/arrayUtils";
import {pascalCase} from "utils/stringUtils";
import theme from "theme/index.scss";
import {FieldNames} from "./fields";

export const DEFAULT_RESULTS_PER_PAGE = 25;
export const REDUCED_RESULTS_PER_PAGE = 5;
export const DEFAULT_PAGE = 1;

export const FIELD_WITHOUT_VALUE = {
  NotSpecified: {value: "NotSpecified", name: "Not Specified"}
};

export const ALL_OPTION = {title: "All", value: "all"};

export const SORT_ORDER = [
  {title: "Ascending", value: "asc"},
  {title: "Descending", value: "desc"}
];

export const SORT_ORDER_MAP = makeObjectFromArray(SORT_ORDER, FieldNames.value);

/* Incidents */
export const INCIDENTS_SORT_BY = [
  {value: FieldNames.incidentTimeOpened, name: "Created"},
  {value: FieldNames.scoresGlobal, name: "Priority"},
  {value: FieldNames.source, name: "Source"},
  {value: FieldNames.title, name: "Title"},
  {value: FieldNames.tactics, name: "Tactic Scores"}
];

export const INCIDENTS_SORT_BY_MAP = makeObjectFromArray(
  INCIDENTS_SORT_BY,
  FieldNames.value
);

export const DATE_RANGES = [
  {value: "TODAY", name: "Last 24 hours"},
  {value: "LAST7DAYS", name: "Last 7 days"},
  {value: "LAST30DAYS", name: "Last 30 days"},
  {value: "LASTYEAR", name: "Last year"},
  {value: "CUSTOM", name: "Custom range"}
];

export const DATE_RANGES_MAP = makeObjectFromArray(
  DATE_RANGES,
  FieldNames.value
);

export const EVENTS_SORT_BY = [
  {
    title: "Observed Start Time",
    value: FieldNames.observedTime
  },
  {
    title: "Severity",
    value: FieldNames.severity
  }
];

export const EVENTS_SORT_BY_MAP = makeObjectFromArray(
  EVENTS_SORT_BY,
  FieldNames.value,
  pascalCase
);

export const ASSIGNMENT = [
  {value: "Self", name: "Assigned to Me"},
  {value: "Others", name: "Assigned to Others"},
  {value: "Unassigned", name: "Unassigned"}
];

export const ASSIGNMENT_MAP = makeObjectFromArray(
  ASSIGNMENT,
  FieldNames.value,
  pascalCase
);

export const STATUS = [
  {value: "Closed", name: "Closed"},
  {
    value: "Containment Achieved",
    name: "Containment Achieved"
  },
  {value: "Incident Reported", name: "Incident Reported"},
  {value: "New", name: "New"},
  {value: "Open", name: "Open"},
  {value: "Rejected", name: "Rejected"},
  {
    value: "Restoration Achieved",
    name: "Restoration Achieved"
  },
  {value: "Stalled", name: "Stalled"}
];

export const STATUS_MAP = makeObjectFromArray(
  STATUS,
  FieldNames.value,
  pascalCase
);

export const INCIDENT_ACTIONS = {
  Link: {value: "incident.link", name: "Link"}
};

/**
 * @var value is returned from the API. "Clean" used to be considered the
 * highest priority. That has changed to "Malicious", which is why the values
 * don't match the priority numbers.
 */
export const DISPOSITIONS = [
  {
    title: "Clean",
    value: 1,
    priority: 5,
    color: theme.dispositionClean
  },
  {
    title: "Malicious",
    value: 2,
    priority: 1,
    color: theme.dispositionMalicious
  },
  {
    title: "Suspicious",
    value: 3,
    priority: 2,
    color: theme.dispositionSuspicious
  },
  {
    title: "Common",
    value: 4,
    priority: 3,
    color: theme.dispositionCommon
  },
  {
    title: "Unknown",
    value: 5,
    priority: 4,
    color: theme.dispositionUnknown
  }
];

export const DISPOSITIONS_BY_PRIORITY = DISPOSITIONS.sort(
  (a, b) => a.priority - b.priority
);

export const DISPOSITIONS_BY_NAME = makeObjectFromArray(
  DISPOSITIONS,
  FieldNames.title
);

export const EVENT_TYPE_OPTIONS = [
  ALL_OPTION,
  {title: "Original", value: "original"},
  {title: "Investigated", value: "investigated"}
];

export const EVENT_TYPE_OPTIONS_MAP = makeObjectFromArray(
  EVENT_TYPE_OPTIONS,
  FieldNames.value
);

export const SEVERITY = [
  {
    color: theme.severityTextColor,
    bgColor: theme.severityCritical,
    priority: 7,
    title: "Critical",
    value: "Critical"
  },
  {
    color: theme.severityTextColor,
    bgColor: theme.severityHigh,
    priority: 6,
    title: "High",
    value: "High"
  },
  {
    color: theme.severityTextColor,
    bgColor: theme.severityMedium,
    priority: 5,
    title: "Medium",
    value: "Medium"
  },
  {
    color: theme.severityTextColor,
    bgColor: theme.severityLow,
    priority: 4,
    title: "Low",
    value: "Low"
  },
  {
    color: theme.severityTextColorDark,
    bgColor: theme.severityNone,
    priority: 3,
    title: "None",
    value: "None"
  },
  {
    color: theme.severityTextColor,
    bgColor: theme.severityUnknown,
    priority: 2,
    title: "Unknown",
    value: "Unknown"
  },
  {
    color: theme.severityTextColor,
    bgColor: theme.severityInfo,
    priority: 1,
    title: "Info",
    value: "Info"
  }
];

export const SEVERITY_MAP = makeObjectFromArray(SEVERITY, FieldNames.value);

export const SEVERITY_OPTIONS = [ALL_OPTION, ...SEVERITY];

export const SAVED_INVESTIGATIONS_FILTER_SORT_DEFAULT = {
  order: SORT_ORDER_MAP.desc.value,
  orderBy: FieldNames.timestamp
};

export const INCIDENT_FILTER_SORT_DEFAULT = {
  assigneeFilter: [],
  assigneeQuery: "",
  dateRangeFilter: {filter: DATE_RANGES_MAP.LAST30DAYS.value},
  order: SORT_ORDER_MAP.desc.value,
  orderBy: INCIDENTS_SORT_BY_MAP[FieldNames.scoresGlobal].value,
  statusFilter: [],
  statusQuery: ""
};

export const INCIDENT_FILTER_SORT_OPTIONS = {
  assigneeFilter: ASSIGNMENT_MAP,
  dateRangeFilter: DATE_RANGES_MAP,
  order: SORT_ORDER_MAP,
  orderBy: INCIDENTS_SORT_BY_MAP,
  statusFilter: STATUS_MAP
};
